export enum InProgressInvoiceActionNameEnum {
  SEND_TO_OCR = 'SEND_TO_OCR',
  HISTORY = 'HISTORY',
}
